function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { Controller } from 'stimulus';
import { dispatchLifecycleEvent } from './lifecycle';
import { uuidv4, serializeForm } from './utils';
import { beforeDOMUpdate, afterDOMUpdate, routeReflexEvent } from './callbacks';
import reflexes, { registerReflex, setupDeclarativeReflexes } from './reflexes';
import { attributeValues } from './attributes';
import Schema from './schema';
import Log from './log';
import Debug from './debug';
import Deprecate from './deprecate';
import ReflexData from './reflex_data';
import isolationMode from './isolation_mode';
import actionCable from './transports/action_cable'; // Default StimulusReflexController that is implicitly wired up as data-controller for any DOM elements
// that have configured data-reflex. Note that this default can be overridden when initializing the application.
// i.e. StimulusReflex.initialize(myStimulusApplication, MyCustomDefaultController);
//

var StimulusReflexController = /*#__PURE__*/function (_Controller) {
  _inherits(StimulusReflexController, _Controller);

  var _super = _createSuper(StimulusReflexController);

  function StimulusReflexController() {
    var _this;

    _classCallCheck(this, StimulusReflexController);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    register(_assertThisInitialized(_this));
    return _this;
  }

  return StimulusReflexController;
}(Controller); // Initializes StimulusReflex by registering the default Stimulus controller with the passed Stimulus application.
//
// - application  - the Stimulus application
// - options
//   * controller - [optional] the default StimulusReflexController
//   * consumer   - [optional] the ActionCable consumer
//   * debug      - [false] log all Reflexes to the console
//   * params     - [{}] key/value parameters to send during channel subscription
//   * isolate    - [false] restrict Reflex playback to the tab which initiated it
//   * deprecate  - [true] show warnings regarding upcoming changes to the library
//


var initialize = function initialize(application) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      controller = _ref.controller,
      consumer = _ref.consumer,
      debug = _ref.debug,
      params = _ref.params,
      isolate = _ref.isolate,
      deprecate = _ref.deprecate;

  actionCable.set(consumer, params);
  document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.remove('stimulus-reflex-connected');
    document.body.classList.add('stimulus-reflex-disconnected');
    if (Deprecate.enabled && consumer) console.warn("Deprecation warning: the next version of StimulusReflex will obtain a reference to consumer via the Stimulus application object.\nPlease add 'application.consumer = consumer' to your index.js after your Stimulus application has been established, and remove the consumer key from your StimulusReflex initialize() options object.");
    if (Deprecate.enabled && isolationMode.disabled) console.warn('Deprecation warning: the next version of StimulusReflex will standardize isolation mode, and the isolate option will be removed.\nPlease update your applications to assume that every tab will be isolated.');
  }, {
    once: true
  });
  isolationMode.set(!!isolate);
  reflexes.app = application;
  Schema.set(application);
  reflexes.app.register('stimulus-reflex', controller || StimulusReflexController);
  Debug.set(!!debug);
  if (typeof deprecate !== 'undefined') Deprecate.set(deprecate);
  var observer = new MutationObserver(setupDeclarativeReflexes);
  observer.observe(document.documentElement, {
    attributeFilter: [Schema.reflex, Schema.action],
    childList: true,
    subtree: true
  });
}; // Registers a Stimulus controller and extends it with StimulusReflex behavior
//
// controller - the Stimulus controller
// options - [optional] configuration
//


var register = function register(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var channel = 'StimulusReflex::Channel';
  controller.StimulusReflex = _objectSpread(_objectSpread({}, options), {}, {
    channel: channel
  });
  actionCable.createSubscription(controller);
  Object.assign(controller, {
    // Indicates if the ActionCable web socket connection is open.
    // The connection must be open before calling stimulate.
    //
    isActionCableConnectionOpen: function isActionCableConnectionOpen() {
      return this.StimulusReflex.subscription.consumer.connection.isOpen();
    },
    // Invokes a server side reflex method.
    //
    // - target - the reflex target (full name of the server side reflex) i.e. 'ReflexClassName#method'
    // - reflexElement - [optional] the element that triggered the reflex, defaults to this.element
    // - options - [optional] an object that contains at least one of attrs, reflexId, selectors, resolveLate, serializeForm
    // - *args - remaining arguments are forwarded to the server side reflex method
    //
    stimulate: function stimulate() {
      var _this2 = this;

      var url = location.href;
      var args = Array.from(arguments);
      var target = args.shift() || 'StimulusReflex::Reflex#default_reflex';
      var controllerElement = this.element;
      var reflexElement = args[0] && args[0].nodeType === Node.ELEMENT_NODE ? args.shift() : controllerElement;

      if (reflexElement.type === 'number' && reflexElement.validity && reflexElement.validity.badInput) {
        if (Debug.enabled) console.warn('Reflex aborted: invalid numeric input');
        return;
      }

      var options = {};

      if (args[0] && _typeof(args[0]) === 'object' && Object.keys(args[0]).filter(function (key) {
        return ['attrs', 'selectors', 'reflexId', 'resolveLate', 'serializeForm', 'suppressLogging', 'includeInnerHTML', 'includeTextContent'].includes(key);
      }).length) {
        var opts = args.shift();
        Object.keys(opts).forEach(function (o) {
          return options[o] = opts[o];
        });
      }

      var reflexData = new ReflexData(options, reflexElement, controllerElement, this.identifier, Schema.reflexPermanent, target, args, url, tabId);
      var reflexId = reflexData.reflexId;
      if (!this.isActionCableConnectionOpen()) throw 'The ActionCable connection is not open! `this.isActionCableConnectionOpen()` must return true before calling `this.stimulate()`';
      if (!actionCable.subscriptionActive) throw 'The ActionCable channel subscription for StimulusReflex was rejected.'; // lifecycle setup

      controllerElement.reflexController = controllerElement.reflexController || {};
      controllerElement.reflexData = controllerElement.reflexData || {};
      controllerElement.reflexError = controllerElement.reflexError || {};
      controllerElement.reflexController[reflexId] = this;
      controllerElement.reflexData[reflexId] = reflexData.valueOf();
      dispatchLifecycleEvent('before', reflexElement, controllerElement, reflexId);
      setTimeout(function () {
        var _ref2 = controllerElement.reflexData[reflexId] || {},
            params = _ref2.params;

        var check = reflexElement.attributes[Schema.reflexSerializeForm];

        if (check) {
          // not needed after v4 because this is only here for the deprecation warning
          options['serializeForm'] = check.value !== 'false';
        }

        var form = reflexElement.closest(reflexData.formSelector) || document.querySelector(reflexData.formSelector) || reflexElement.closest('form');
        if (Deprecate.enabled && options['serializeForm'] === undefined && form) console.warn("Deprecation warning: the next version of StimulusReflex will not serialize forms by default.\nPlease set ".concat(Schema.reflexSerializeForm, "=\"true\" on your Reflex Controller Element or pass { serializeForm: true } as an option to stimulate."));
        var formData = options['serializeForm'] === false ? '' : serializeForm(form, {
          element: reflexElement
        });
        controllerElement.reflexData[reflexId] = _objectSpread(_objectSpread({}, reflexData.valueOf()), {}, {
          params: params,
          formData: formData
        });

        _this2.StimulusReflex.subscription.send(controllerElement.reflexData[reflexId]);
      });
      var promise = registerReflex(reflexData.valueOf());
      Log.request(reflexId, target, args, this.context.scope.identifier, reflexElement, controllerElement);
      return promise;
    },
    // Wraps the call to stimulate for any data-reflex elements.
    // This is internal and should not be invoked directly.
    __perform: function __perform(event) {
      var element = event.target;
      var reflex;

      while (element && !reflex) {
        reflex = element.getAttribute(Schema.reflex);
        if (!reflex || !reflex.trim().length) element = element.parentElement;
      }

      var match = attributeValues(reflex).find(function (reflex) {
        return reflex.split('->')[0] === event.type;
      });

      if (match) {
        event.preventDefault();
        event.stopPropagation();
        this.stimulate(match.split('->')[1], element);
      }
    }
  });
}; // Uniquely identify this browser tab in each Reflex


var tabId = uuidv4();

var useReflex = function useReflex(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  register(controller, options);
};

document.addEventListener('cable-ready:after-dispatch-event', routeReflexEvent);
document.addEventListener('cable-ready:before-inner-html', beforeDOMUpdate);
document.addEventListener('cable-ready:before-morph', beforeDOMUpdate);
document.addEventListener('cable-ready:after-inner-html', afterDOMUpdate);
document.addEventListener('cable-ready:after-morph', afterDOMUpdate);
window.addEventListener('load', setupDeclarativeReflexes);
export default {
  initialize: initialize,
  register: register,
  useReflex: useReflex,

  get debug() {
    return Debug.value;
  },

  set debug(value) {
    Debug.set(!!value);
  },

  get deprecate() {
    return Deprecate.value;
  },

  set deprecate(value) {
    Deprecate.set(!!value);
  }

};